import { history } from 'instantsearch.js/es/lib/routers';

export function historyRouter(options = {}) {
  return history({
    cleanUrlOnDispose: false,
    ...options,
  });
}

export function createStateMapping(
  indexName,
  defaultToggleState = {},
  defaultRefinementState = {},
) {
  return {
    stateToRoute(uiState) {
      const indexUiState = uiState[indexName] || {};
      const route = {
        q: indexUiState.query,
        page: indexUiState.page,
      };

      Object.entries(indexUiState.refinementList || {}).forEach(
        ([key, value]) => {
          const defaultValue = defaultRefinementState[key];
          const currentSorted = [...value].sort().join(',');
          const defaultSorted = defaultValue
            ? [...defaultValue].sort().join(',')
            : '';

          if (currentSorted !== defaultSorted) {
            route[key] = value.join(',');
          }
        },
      );

      Object.entries(defaultRefinementState).forEach(([key]) => {
        const currentValue = indexUiState.refinementList?.[key];
        if (!currentValue || currentValue.length === 0) {
          route[`clear_${key}`] = '1';
        }
      });

      Object.entries(indexUiState.toggle || {}).forEach(([key, value]) => {
        if (value !== defaultToggleState[key]) {
          route[`toggle_${key}`] = value ? '1' : '0';
        }
      });

      Object.entries(defaultToggleState).forEach(([key]) => {
        const currentValue = indexUiState.toggle?.[key];
        if (currentValue === false) {
          route[`toggle_${key}`] = '0';
        }
      });

      return route;
    },
    routeToState(routeState) {
      const refinementList = { ...defaultRefinementState };
      const range = {};
      const toggle = { ...defaultToggleState };

      Object.entries(routeState).forEach(([key, value]) => {
        if (key === 'q' || key === 'page') return;

        if (key.startsWith('toggle_')) {
          const attr = key.replace('toggle_', '');
          toggle[attr] = value === '1';
        } else if (key.startsWith('clear_')) {
          const attr = key.replace('clear_', '');
          delete refinementList[attr];
        } else if (key.endsWith('_min') || key.endsWith('_max')) {
          const attr = key.replace(/_min$|_max$/, '');
          if (!range[attr]) range[attr] = {};
          if (key.endsWith('_min')) range[attr].min = value;
          if (key.endsWith('_max')) range[attr].max = value;
        } else if (value) {
          refinementList[key] = value.split(',');
        }
      });

      return {
        [indexName]: {
          query: routeState.q,
          page: routeState.page,
          refinementList,
          range,
          toggle,
        },
      };
    },
  };
}
